import React, { useEffect, useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../components/elements/Loader'
import EmptyState from '../../../components/elements/EmptyState'
import ArrowUpTrayIcon from '../../../components/elements/icons/ArrowUpTrayIcon'
import DataTable from '../../../components/elements/DataTable'
import { debounce, tableHeadersFields, transactionTimeStamp } from '../../../utils'
import { Link } from 'react-router-dom'
import PlusIcon from '../../../components/elements/icons/PlusIcon'
import Breadcrumbs from '../../../components/elements/Breadcrumbs'
import { clearResentInvitation, fetchStaff, resendInvitation, revokeInvitation } from '../../../store/actions/staffActions'
import StaffTableSnippet from '../../../components/partials/staff/StaffTableSnippet'
import TrashIcon from '../../../components/elements/icons/TrashIcon'
import ArrowPathIcon from '../../../components/elements/icons/ArrowPathIcon'
import { SET_SUCCESS } from '../../../store/types'
import SearchField from '../../../components/elements/SearchField';


const CollegeStaff = () => {
    const dispatch = useDispatch()
    const staffSelector = useSelector((state => state.staff))
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);

    const [reload, setReload] = useState(1);
  
    useEffect(() => {
      dispatch(fetchStaff('', page, perPage))

      if(staffSelector.resentInvitation !== null){
        dispatch({
          type: SET_SUCCESS,
          payload: 'Invitation resent successfully'
        })
        dispatch(clearResentInvitation())
      }

      if(staffSelector.revokedInvitation !== null){
        dispatch({
          type: SET_SUCCESS,
          payload: 'Invitation revoked successfully'
        })
      }

      return () => {
        
      };
    }, [page, perPage, dispatch, staffSelector.resentInvitation, staffSelector.revokedInvitation, reload]);
  
    const tableOptions = {
      selectable: true,
      multiselect: true,
      clickableRows: true,
      rowAction: (rowIndex)=>{
        
      }
    }
  
    const columnWidths = {
      staffId: 'w-2/12',
      staff: 'w-3/12',
      "department/designation": 'w-3/12',
      dateAdded: 'w-1/12',
      systemAccess: 'w-2/12',
      onboarding: 'w-1/12'
    }
  
    const columnDataStyles = {}

    const StaffSystemAccess = ({accessType, invitation}) => {
      const staffSelector = useSelector((state => state.staff))
      const doRevokeInvitation = (invitationId) => {
        if(window.confirm('Are you sure you want to revoke this invitation?')){
          dispatch(revokeInvitation(invitationId))
        }
      }

      return (
        <div className='flex items-center justify-between w-full -mt-[5px]'>
          <span className={`px-[6px] py-[3px] text-xs capitalize
            ${accessType === 'available' && 'bg-green-100 text-green-600'} 
            ${accessType === 'pending' && 'bg-yellow-500 bg-opacity-10 text-yellow-800'} 
            ${accessType === 'none' && 'bg-red-100 text-red-600'} 
          `}>
            {accessType}
          </span>

          {accessType === 'pending' && <div className='flex items-center w-max flex-row-reverse gap-x-[2px]'>
            <button onClick={()=>{doRevokeInvitation(invitation._id)}} className='h-[30px] px-[6px] flex items-center justify-center gap-x-[3px] rounded text-gray-600 hover:bg-gray-200 hover:text-red-500 transition duration-200 text-xs'>
              <TrashIcon className={`w-4 h-4`} />
              {staffSelector.revokingInvitation === invitation._id ? 'Revoking...' : 'Revoke'}
            </button>
            <button onClick={()=>{dispatch(resendInvitation(invitation._id))}} className='h-[30px] px-[6px] flex items-center justify-center gap-x-[3px] rounded text-gray-600 hover:bg-gray-200 hover:text-gray-700 transition duration-200 text-xs'>
              <ArrowPathIcon className={`w-4 h-4 ${staffSelector.resendingInvitation === invitation._id ? 'animate-spin' : ''}`} />
              Resend
            </button>
          </div>}
        </div>
      )
    }
    // navigate(staffSelector.staffMembers.staff[rowIndex]._id)
    
    const cleanUpTableData = (array) => {
      if(!array) return
      let finalResult = [] 
      array.forEach((object, objectIndex) => {
          const staffObject = {
            staff: <Link to={object._id}><StaffTableSnippet staff={object} /></Link>,
            staffId: object.staffId,
            "department/designation": <p className='text-sm'>{object?.department?.name}<br/> 
            <span className='text-gray-500'>{object?.designations?.map(designation => designation?.name).join(', ') || 'Not set'}</span></p>,
            dateAdded: transactionTimeStamp(object?.createdAt)?.date,
            systemAccess: <StaffSystemAccess accessType={object?.invitation?.userProfileRequired && !object?.userProfile ? 'pending' : object?.userProfile ? 'available' : 'none'} invitation={object?.invitation} />,
            onboarding: <span className={`px-[6px] py-[3px] text-xs capitalize
            ${object?.onboardingComplete ? 'bg-green-100 text-green-600' : 'bg-yellow-500 bg-opacity-10 text-yellow-800'} 
          `}>
            {object?.onboardingComplete ? 'Onboarded' : 'Pending'}
          </span>
          }
  
          finalResult.push(staffObject)
      })
      return finalResult
    }
  
    // const [view, setView] = useState(staffDefaultDisplay() || 'list');
    // const changeStaffView = (view) => {
    //   localStorage.setItem("studentsDefaultDisplay", view);
    //   setView(view)
    // }

    const breadcrumbsData = [
        {
            label: 'Dashboard',
            path: '/dashboard/wallets'
        },
        {
            label: 'College Staff',
            path: '/dashboard/admin/college-staff',
            current: true
        },
    ]

    const searchStaff = debounce((term) => {
      if(!term || term === '') setReload(reload + 1)
      dispatch(fetchStaff(`searchTerm=${term}`, 0, 0))
    })
  
    return (
      <Layout pageTitle={`VCM Staff`}>
        <Breadcrumbs breadcrumbsData={breadcrumbsData} />
        <div className='w-full p-8'>
          <div className="w-full mx-auto flex items-center justify-between">
            <div className='w-8/12'>
                <h4 className='font-medium text-lg mb-3 text-gray-400'>Members of Staff</h4>
                <div className='w-2/3'>
                    <p className='text-gray-500 my-3 text-sm'>
                        Below is a list of Staff at Vaatia College
                    </p>
                </div>
            </div>
            <div className='w-4/12 flex flex-row-reverse'>
                <Link to={`onboard-new-staff`} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    <PlusIcon className='w-5 h-5' /> Onboard new staff
                </Link>
            </div>
          </div>
  
          <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
            {/* <div className='w-full'>
              <Filters filterOptions={filterOptions} />
            </div> */}
            <div className='w-full flex flex-row-reverse gap-x-2'>
              <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                <ArrowUpTrayIcon className={`w-5 h-5`} />
                Export Staff
              </button>
              
              {/* <button onClick={()=>{changeStaffView('grid')}} className={`${view === 'grid' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                <SquaresIcon className={`w-7 h-7`} />
              </button>
  
              <button onClick={()=>{changeStaffView('list')}} className={`${view === 'list' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                <ViewListIcon className={`w-7 h-7`} />
              </button> */}
              <div className='w-[370px]'>
                <SearchField 
                  placeholderText={`Search by staff name, email, phone or staff ID`}
                  showResultsDropDown={false}
                  triggerSearch={(term)=>{searchStaff(term)}}
                  performingSearch={staffSelector.loadingStaff}
                />
              </div>
            </div>
          </div>
  
          {staffSelector?.loadingStaff ? 
            <Loader />
            :
            <>
              {staffSelector?.staffMembers?.staff?.length > 0 ? 
                <div className=''>
                  {<div className='w-full'>
                    <DataTable
                      tableHeaders={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers.staff)[0]).headers} 
                      tableData={cleanUpTableData(staffSelector.staffMembers?.staff)} 
                      columnWidths={columnWidths}
                      columnDataStyles={columnDataStyles}
                      allFields={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers?.staff)[0]).fields}
                      onSelectItems={()=>{}}
                      tableOptions={tableOptions}
                      pagination={{
                          perPage, 
                          currentPage:page,
                          totalItems: staffSelector.staffMembers.total,
                      }}
                      onSelectSingle={()=>{}}
                      changePage={setPage}
                      updatePerPage={setPerPage}
                    />
                  </div>
                  }
                </div>
                : 
                <div className='mt-24 w-1/2 mx-auto'>
                  <EmptyState emptyStateText={`There are no staff on this platform yet! You can onboard new members of staff by clicking on "Onboard Staff" above`} />
                </div>
  
              }
            </>
          }
        </div>
      </Layout>
    )
  }
  

export default CollegeStaff